// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fecske */
@keyframes slideInFecskeHover {
    0%   { left:-75vw; top:0px;}
    100% { left:0px; top:0px;}
  }

  @keyframes slideOutFecskeHover {
    0%  { left:0px; top:0px;}
    100% { left:-75vw; top:0px;}
  }

  @keyframes slideInFecskeHoverVericalLine {
    0%   { left:50%; top:0px;}
    100% { left:64.6%; top:0px;}
  }

  @keyframes slideOutFecskeHoverVericalLine {
    0%   { left:64.6%; top:0px;}
    100% { left:50%; top:0px;}
  }

/* Kisfecske */
  @keyframes slideInKisfecskeHover {
    0%   { right:-75vw; top:0px;}
    100% { right:0px; top:0px;}
  }

  @keyframes slideOutKisfecskeHover {
    0%  { right:0px; top:0px;}
    100% { right:-75vw; top:0px;}
  }

  @keyframes slideInKisfecskeHoverVericalLine {
    0%   { right:50%; top:0px;left:unset}
    100% { right:64.6%; top:0px; left:unset}
  }

  @keyframes slideOutKisfecskeHoverVericalLine {
    0%   { right:64.6%; top:0px;left:unset}
    100% { right:50%; top:0px;left:unset}
  }

/* General */

  @keyframes blurIn {
    0%  { -webkit-filter: blur(0px);}
    100% { -webkit-filter: blur(5px);}
  }

  @keyframes blurOut {
    0%  { -webkit-filter: blur(5px);}
    100% { -webkit-filter: blur(0px);}
  }

`, "",{"version":3,"sources":["webpack://./src/styles/animation.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,OAAO,UAAU,EAAE,OAAO,CAAC;IAC3B,OAAO,QAAQ,EAAE,OAAO,CAAC;EAC3B;;EAEA;IACE,MAAM,QAAQ,EAAE,OAAO,CAAC;IACxB,OAAO,UAAU,EAAE,OAAO,CAAC;EAC7B;;EAEA;IACE,OAAO,QAAQ,EAAE,OAAO,CAAC;IACzB,OAAO,UAAU,EAAE,OAAO,CAAC;EAC7B;;EAEA;IACE,OAAO,UAAU,EAAE,OAAO,CAAC;IAC3B,OAAO,QAAQ,EAAE,OAAO,CAAC;EAC3B;;AAEF,cAAc;EACZ;IACE,OAAO,WAAW,EAAE,OAAO,CAAC;IAC5B,OAAO,SAAS,EAAE,OAAO,CAAC;EAC5B;;EAEA;IACE,MAAM,SAAS,EAAE,OAAO,CAAC;IACzB,OAAO,WAAW,EAAE,OAAO,CAAC;EAC9B;;EAEA;IACE,OAAO,SAAS,EAAE,OAAO,CAAC,UAAU;IACpC,OAAO,WAAW,EAAE,OAAO,EAAE,UAAU;EACzC;;EAEA;IACE,OAAO,WAAW,EAAE,OAAO,CAAC,UAAU;IACtC,OAAO,SAAS,EAAE,OAAO,CAAC,UAAU;EACtC;;AAEF,YAAY;;EAEV;IACE,MAAM,yBAAyB,CAAC;IAChC,OAAO,yBAAyB,CAAC;EACnC;;EAEA;IACE,MAAM,yBAAyB,CAAC;IAChC,OAAO,yBAAyB,CAAC;EACnC","sourcesContent":["/* Fecske */\n@keyframes slideInFecskeHover {\n    0%   { left:-75vw; top:0px;}\n    100% { left:0px; top:0px;}\n  }\n\n  @keyframes slideOutFecskeHover {\n    0%  { left:0px; top:0px;}\n    100% { left:-75vw; top:0px;}\n  }\n\n  @keyframes slideInFecskeHoverVericalLine {\n    0%   { left:50%; top:0px;}\n    100% { left:64.6%; top:0px;}\n  }\n\n  @keyframes slideOutFecskeHoverVericalLine {\n    0%   { left:64.6%; top:0px;}\n    100% { left:50%; top:0px;}\n  }\n\n/* Kisfecske */\n  @keyframes slideInKisfecskeHover {\n    0%   { right:-75vw; top:0px;}\n    100% { right:0px; top:0px;}\n  }\n\n  @keyframes slideOutKisfecskeHover {\n    0%  { right:0px; top:0px;}\n    100% { right:-75vw; top:0px;}\n  }\n\n  @keyframes slideInKisfecskeHoverVericalLine {\n    0%   { right:50%; top:0px;left:unset}\n    100% { right:64.6%; top:0px; left:unset}\n  }\n\n  @keyframes slideOutKisfecskeHoverVericalLine {\n    0%   { right:64.6%; top:0px;left:unset}\n    100% { right:50%; top:0px;left:unset}\n  }\n\n/* General */\n\n  @keyframes blurIn {\n    0%  { -webkit-filter: blur(0px);}\n    100% { -webkit-filter: blur(5px);}\n  }\n\n  @keyframes blurOut {\n    0%  { -webkit-filter: blur(5px);}\n    100% { -webkit-filter: blur(0px);}\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
